// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const CaretDown: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.749 7.503">
            <path
                fill="currentColor"
                fillRule="nonzero"
                d="m13.457 1.624-5.938 5.59a.844.844 0 0 1-.644.29.938.938 0 0 1-.645-.257L.293 1.624A.942.942 0 0 1 .256.296.936.936 0 0 1 1.582.261l5.293 5.012L12.168.257a.937.937 0 0 1 1.326.037.947.947 0 0 1-.037 1.33Z"
            />
        </svg>
    );
};

export default React.memo(CaretDown);
